import { useFocusContext } from '../context/FocusContext';
export const useHasBeenFocused = () => useFocusContext().hasBeenFocused;